'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright (c) 2015-present, Zippy Technologies
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                               * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                               */

var _positionsMap = require('./positionsMap');

var _positionsMap2 = _interopRequireDefault(_positionsMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createEmptyArray(length, fn) {
  return Array.apply(null, Array(length)).map(fn);
}

function handleNumericOffset(offset, offsetCorrection) {
  var normalizedOffset = {
    x: offset * offsetCorrection.x,
    y: offset * offsetCorrection.y
  };

  if (offsetCorrection.resetNumeric) {
    normalizedOffset[offsetCorrection.resetNumeric] = 0;
  }

  return normalizedOffset;
}

function handleObjectOffset(offset, offsetCorrection) {
  var normalizedOffset = {
    x: offset.x === undefined ? 0 : offset.x * offsetCorrection.x,
    y: offset.y === undefined ? 0 : offset.y * offsetCorrection.y
  };

  return normalizedOffset;
}

/**
 * If offset is a number|object, returns an array of given length
 * with this number.
 * If is an array, and are not the same length, it will fill the array
 * with the last item the difference
 * @param {Number|Object|Number[]|Object[]} offset          [description]
 * @param {Number} positionsLength
 */
function normalizeOffset(offset, positionsLength) {
  var normalizedOffsets = null;

  if (typeof offset === 'number' || !Array.isArray(offset) && (typeof offset === 'undefined' ? 'undefined' : _typeof(offset)) === 'object') {
    normalizedOffsets = createEmptyArray(positionsLength, function () {
      return offset;
    });
  } else if (Array.isArray(offset)) {
    if (offset.length < positionsLength) {
      var lastOffsetItem = offset[offset.length - 1];
      var extraOffsets = createEmptyArray(positionsLength - offset.length, function () {
        return lastOffsetItem;
      });
      normalizedOffsets = [].concat(_toConsumableArray(offset), _toConsumableArray(extraOffsets));
    } else {
      normalizedOffsets = offset;
    }
  }

  return normalizedOffsets;
}

/**
 * Corrects offset so it is applied relative to its position.
 *
 * Numeric.
 * When it is numeric it should position itself oposite to it's target position.
 * Offset 10.
 * Position top. y axis is affected
 * Position top left. both y and x are affected
 *
 * Object.
 * Offset is corrected using positionMap offset correction.
 * For example.
 * offset { x, y }
 * x is used as it is, but y is multiplied with -1, so tooltip
 * will be 10 px above the target.
 *
 * @param {[type]} offset           [description]
 * @param {[type]} offsetCorrection [description]
 */
function getPositionOffsets(positions, offset) {
  var normalizedOffsets = normalizeOffset(offset, positions.length);
  var positionOffsets = normalizedOffsets.map(function (normalizedOffset, index) {
    var position = positions[index];
    var positionMap = _positionsMap2.default[position];
    var offsetCorrection = positionMap ? positionMap.offset : position.offset || { x: 0, y: 0 };

    if (typeof normalizedOffset === 'number') {
      return handleNumericOffset(normalizedOffset, offsetCorrection);
    }

    return handleObjectOffset(normalizedOffset, offsetCorrection);
  });

  return positionOffsets;
}

exports.default = getPositionOffsets;